import { render, staticRenderFns } from "./SocketTest.vue?vue&type=template&id=7df917c3&scoped=true"
import script from "./SocketTest.vue?vue&type=script&lang=js"
export * from "./SocketTest.vue?vue&type=script&lang=js"
import style0 from "./SocketTest.vue?vue&type=style&index=0&id=7df917c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df917c3",
  null
  
)

export default component.exports